import { render, staticRenderFns } from "./igmpending.vue?vue&type=template&id=4793642c&scoped=true&"
import script from "./igmpending.vue?vue&type=script&lang=js&"
export * from "./igmpending.vue?vue&type=script&lang=js&"
import style0 from "./igmpending.vue?vue&type=style&index=0&id=4793642c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4793642c",
  null
  
)

export default component.exports